import { message } from "antd";
import moment from "moment";
import { ChatMessageItem } from "../models/ChatStores";

export const getSecondsSinceMessage = (
  chatMessage?: ChatMessageItem, 
  _dateTime?: Date // unit testing only - do not use
): number => {
  if (!chatMessage || !chatMessage?.date) {
    return -1;
  }

  const now: moment.Moment = moment(_dateTime || new Date());
  const messageDate: moment.Moment = moment(chatMessage.date);

  return now.isAfter(messageDate)
    ? now.diff(chatMessage.date, 'seconds')
    : messageDate.diff(now, 'seconds')
}